export { getAvailableProperties } from './getAvailableProperties'
